const QUERYPARAMS_GET_SUCCESS = 'QUERYPARAMS_GET_SUCCESS';

export default QUERYPARAMS_GET_SUCCESS;
